import {
  HttpClient,
  HttpErrorResponse,
  HttpParams,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AddCompanyResponse,
  CompanyCommonResponse,
  CompanyItem,
  CompanyResponse,
} from '@core/interface/company';
import { PagePayload } from '@core/interface/core';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  constructor(private http: HttpClient) {}

  getCompanies(filter?: PagePayload) {
    let httpParams = new HttpParams();
    if (filter)
      Object.keys(filter).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (filter[key as keyof PagePayload] as any) || ''
        );
      });
    return this.http.get<CompanyResponse>(environment.endPoints.companyList, {
      params: httpParams,
    });
  }
  addCompany(data: CompanyItem) {
    return this.http.post<AddCompanyResponse>(
      environment.endPoints.companyAddEdit,
      data
    );
  }
  deleteCompany(id: number) {
    return this.http.get<CompanyCommonResponse>(
      environment.endPoints.companyDelete(id)
    );
  }
}
